module.exports = ""


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/baslercommon/views/basler-initial.html
// module id = 721
// module chunks = 0